import { render } from "./AssetBrandAutocomplete.vue?vue&type=template&id=5b22c182"
import script from "./AssetBrandAutocomplete.vue?vue&type=script&lang=js"
export * from "./AssetBrandAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__